import { createClient } from 'contentful';

const client = createClient({
  space: '1ghyjb5qi87t',
  accessToken:
    '179b9161d8a0675ae09c6ae20d1f9d13e0e56ca51ddaf9be5e704bb427960491',
});

export default client;



// WEBPACK FOOTER //
// ./src/api/contentful.ts